import $ from "jquery";
import gsap, { Power2, TimelineMax } from "gsap";
import CSSRulePlugin from "gsap/CSSRulePlugin";

gsap.registerPlugin(CSSRulePlugin);

function pageTransition() {
  $(".loader").css("display", "block");
  var tl = new TimelineMax();
  tl.to(
    CSSRulePlugin.getRule(".transition-wrapper:before"),
    0.5,
    { cssRule: { top: "50%" }, ease: Power2.easeIn },
    "close"
  )
    .to(
      CSSRulePlugin.getRule(".transition-wrapper:after"),
      0.5,
      { cssRule: { bottom: "50%" }, ease: Power2.easeIn },
      "close"
    )
    .to($(".loader"), 0, { opacity: 1 }, "+=0")
    .to(
      CSSRulePlugin.getRule(".transition-wrapper:before"),
      0.5,
      { cssRule: { top: "0%" }, ease: Power2.easeOut },
      "+=2.5",
      "open"
    )
    .to(
      CSSRulePlugin.getRule(".transition-wrapper:after"),
      0.5,
      { cssRule: { bottom: "0%" }, ease: Power2.easeOut },
      "-=0.5",
      "open"
    )
    .to($(".loader"), 0.2, { opacity: 0 }, "-=0.5");
  setTimeout(() => {
    $(".loader").css("display", "none");
  }, 3000);
}

export default pageTransition;
